import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { ReactComponent as ClientPoolRealEstateSvg } from 'assets/svg/client-pool-real-estate.svg';
import ClientPoolTabs from 'components/client-pool/Tabs';
import { useState } from 'react';

export default function ClientPool() {
    const [showClientPoolTabs, setShowClientPoolTabs] = useState(localStorage.getItem('clientPoolTour') === 'true');

    const handleClick = () => {
        localStorage.setItem('clientPoolTour', 'true');
        setShowClientPoolTabs(true);
    };
    return showClientPoolTabs && showClientPoolTabs ? (
        <ClientPoolTabs />
    ) : (
        <>
            <div className="md:h-[90vh] md:items-center p-4 md:justify-center rounded-xl xs:hidden flex">
                <div className="w-full max-w-6xl grid grid-cols-2 gap-8  bg-white rounded-lg shadow-sm">
                    {/* Left Column */}
                    <ClientConnectionSection handleClick={handleClick} />

                    {/* Right Column */}
                    <div className="py-20  bg-gray-50">
                        <div className="flex items-end justify-end">
                            <ClientPoolRealEstateSvg />
                        </div>
                    </div>
                </div>
            </div>
            {/* Mobile Buyer Pool Version */}
            <div className="xs:block hidden p-4">
                <div className="flex flex-col">
                    <div className="bg-gray-50 p-4">
                        <div className="flex justify-end">
                            <ClientPoolRealEstateSvg className="sm:h-96 sm:w-96 w-full h-full" />
                        </div>
                    </div>
                    <ClientConnectionSection className="bg-white" handleClick={handleClick} />
                </div>
            </div>
        </>
    );
}

interface Props {
    className?: string;
    handleClick?: () => void;
}

const ClientConnectionSection = ({ className = '', handleClick }: Props) => {
    return (
        <div className={`flex flex-col justify-center space-y-6 py-20 px-10 ${className}`}>
            <div className="space-y-4">
                <h2 className="text-2xl font-semibold leading-[38px] font-poppins">Just one click to unlock your next client connection</h2>
                <p className="text-lg font-poppins leading-6 text-gray-500">
                    Hello:data Buyer Pool is designed to help you find and connect with property clients looking for the perfect match. Whether you're an agent
                    looking to fill specific requests or just exploring potential leads, Buyer Pool makes it easy to find exactly what you're looking for.
                </p>
            </div>
            <button className="flex items-center rounded-md overflow-hidden" onClick={handleClick}>
                <span className="px-4 bg-black py-2.5 text-white">Take a tour</span>
                <div className="w-px h-full bg-white/10" />
                <span className="px-4 bg-black/80 py-2.5 text-white">
                    <ArrowForwardIosIcon className="w-4 h-4" />
                </span>
            </button>
        </div>
    );
};
